<div class="grid mb-2">
	<!-- NO SITE SELECTED ALERT -->
	<div *ngIf="currentSite === undefined" class="col-12 py-0">
		<div class="flex align-items-center justify-content-center bg-yellow-200 p-1 border-round-xl">
			<i class="pi cm-alert text-lg text-yellow-700"></i>
			<p-tag [value]="('NO_SITE_DEVICE_ALERT' | translate)" severity="warning" styleClass="text-lg"></p-tag>
		</div>
	</div>
	<!-- SHARED SITE ALERT -->
	<div *ngIf="currentSite !== undefined && !currentSite.CurrentlyOwned" class="col-12 pt-0">
		<div class="flex align-items-center justify-content-center bg-purple-100 p-1 border-round-xl">
			<i class="pi cm-share text-lg text-purple-700"></i>
			<p-tag [value]="'SHARED_SITE' | translate" styleClass="p-tag-purple"></p-tag>
		</div>
	</div>
</div>
<!-- FILTER -->
<app-devices-vct-list-filters *ngIf="devices && devices.length > 0 || currentSite?.CurrentlyOwned"
	[deviceFilters]="deviceFilters">
</app-devices-vct-list-filters>
<!-- VCT LIST -->
<div *ngIf="devices && devices.length > 0 || currentSite?.CurrentlyOwned" class="card px-0 border-round">
	<div *ngIf="loadingInvitations || loadingList">
		<div class="flex align-items-center justify-content-center w-full pb-8 mb-8">
			<p-progressSpinner ariaLabel="loading"></p-progressSpinner>
		</div>
	</div>
	<p-treeTable *ngIf="!loadingInvitations && !loadingList" [value]="devices" [totalRecords]="devices.length"
		(onNodeExpand)="onDeviceExpand($event)" (onNodeCollapse)="onDeviceCollapse($event)"
		[scrollable]="virtualEnableScroll"
		[scrollHeight]="virtualEnableScroll ? '900px' : null"
		[virtualScroll]="virtualEnableScroll"
		[virtualScrollItemSize]="70">
		<ng-template pTemplate="header" let-columns>
			<!-- <tr>
				<th>{{this.screenWidth >= MIN_WIDTH_COL6 ? this.translate.instant('NAME') : ''}}</th>
				<th *ngIf="this.screenWidth >= MIN_WIDTH_COL6">{{ 'DESCRIPTION' | translate }}</th>
				<th [class]="onExtendedMobile() ? 'w-3rem' : this.screenWidth <= LG_WIDTH ? 'w-9rem' : 'w-12rem'">
					{{ 'SUB_GATEWAY_NEW' | translate }}
				</th>
				<th [class]="onExtendedMobile() ? 'w-3rem' : this.screenWidth <= LG_WIDTH ? 'w-9rem' : 'w-12rem'">
					{{ 'STATUS' | translate }}
				</th>
			</tr> -->
		</ng-template>
		<ng-template pTemplate="body" let-rowNode let-rowData="rowData" let-columns="columns">
			<tr [ttRow]="rowNode" [class]="onExtendedMobile() ? 'flex flex-row' : ''"
				[class]="(rowNode.level === 0) ? 'surface-400 hover:bg-blue-200 border-top-1 border-bluegray-900' : ''">
				<!-- <td [class]="onExtendedMobile() ? 'flex w-full' : ''"> -->
				<td [class]="onExtendedMobile() ? 'w-6rem' : this.screenWidth <= LG_WIDTH ? 'w-9rem' : 'w-12rem'">
					<div class="flex align-items-center justify-content-start text-left">
						<p-treeTableToggler [rowNode]="rowNode"></p-treeTableToggler>
						<i class="pi {{rowNode.node.icon}} text-4xl text-primary mr-3"></i>
						<div class="text-xl font-medium" style="white-space: pre-wrap">{{ rowData.AliasName !== undefined &&
							rowData.AliasName !== ''? getSplitString(rowData.AliasName) : getSplitString(rowData.Name) |
							truncate:[30]}}</div>
					</div>
				</td>
				<td *ngIf="!onExtendedMobile()" [class]="this.screenWidth <= LG_WIDTH ? 'w-9rem' : 'w-12rem'">
					<div class="flex align-items-center justify-content-center text-center">
						<div>{{ getRowInfo(rowData) }}</div>
					</div>
				</td>
				<td [class]="onExtendedMobile() ? 'w-1rem' : this.screenWidth <= LG_WIDTH ? 'w-9rem' : 'w-12rem'">
					<div *ngIf="!onExtendedMobile()" class="flex flex-column">
						<p-tag *ngIf="showTagShare(rowData)" icon="{{getIconTagShare(rowData)}}" value="{{ getTextTagShare(rowData) }}"
							severity="{{ getSeverityTagShare(rowData) }}"></p-tag>
						<p-tag *ngIf="showTagShareInvitation(rowData)" icon="{{getIconTagShare(rowData)}}" value="{{ getTextTagShareInvitation(rowData) }}"
							severity="{{ getSeverityTagShareInvitation(rowData) }}"></p-tag>
					</div>
					<div *ngIf="onExtendedMobile()" class="flex flex-column">
						<p-tag *ngIf="showTagShare(rowData)" icon="{{getIconTagShare(rowData)}}" value=""
							severity="{{ getSeverityTagShare(rowData) }}"></p-tag>
						<p-tag *ngIf="showTagShareInvitation(rowData)" icon="{{getIconTagShare(rowData)}}" value=""
							severity="{{ getSeverityTagShareInvitation(rowData) }}"></p-tag>
					</div>
				</td>
				<td [class]="onExtendedMobile() ? 'w-3rem' : this.screenWidth <= LG_WIDTH ? 'w-9rem' : 'w-12rem'">
					<p-button *ngIf="shareVisible(rowData)"
						pTooltip="{{ isOwner(rowData) ? ('GIVE' | translate) : ('ASSING' | translate) }}"
						tooltipPosition="bottom" icon="pi cm-transfer" size="large" (click)="shareDevice(rowData)"
						[rounded]="false" [text]="true" severity="secondary">
					</p-button>
					<p-button *ngIf="editIntercomContactVisible(rowData)" pTooltip="{{ 'INTERCOM_CONTACT' | translate}}"
						tooltipPosition="bottom" icon="pi cm-users" size="large" (click)="editDeviceName(rowData)"
						[rounded]="false" [text]="true" severity="secondary">
					</p-button>
					<p-button *ngIf="editVisible(rowData)" pTooltip="{{ 'EDIT' | translate}}" tooltipPosition="bottom"
						icon="pi cm-pencil" size="large" (click)="editDeviceName(rowData)" [rounded]="false" [text]="true"
						severity="secondary">
					</p-button>
					<p-button *ngIf="abandonVisible(rowData)" pTooltip="{{ 'ABANDON' | translate}}" tooltipPosition="bottom"
						icon="pi cm-cancel" size="large" (click)="abandonDevice(rowData)" [rounded]="false" [text]="true"
						severity="danger">
					</p-button>
					<p-button *ngIf="resetLicenseVisible(rowData)" pTooltip="{{ 'RESET_LICENSE_APP' | translate}}"
						tooltipPosition="bottom" icon="pi cm-reload" size="large" (click)="resetLicense(rowData)"
						[rounded]="false" [text]="true" severity="danger">
					</p-button>
					<p-button *ngIf="revokeInvitationsVisible(rowData)" pTooltip="{{ 'REVOKE_INVITATION' | translate}}"
						tooltipPosition="bottom" icon="pi cm-cancel" size="large" (click)="revokeInvitationsDevice(rowData)"
						[rounded]="false" [text]="true" severity="danger">
					</p-button>
					<p-button *ngIf="revokeAccessVisible(rowData)" pTooltip="{{ 'REVOKE_ACCESS' | translate}}"
						tooltipPosition="bottom" icon="pi cm-cancel" size="large" (click)="revokeAccessDevice(rowData)"
						[rounded]="false" [text]="true" severity="danger">
					</p-button>
					<p-button *ngIf="configAuxCommandsVisible(rowData)" pTooltip="{{ 'AUXILIARY_COMMANDS' | translate}}"
						tooltipPosition="bottom" icon="pi cm-cog" size="large" (click)="configAuxiliaryCommands(rowData)"
						[rounded]="false" [text]="true" severity="secondary">
					</p-button>
				</td>
			</tr>
		</ng-template>
		<ng-template pTemplate="emptymessage" let-columns>
			<tr>
				<td colspan="7">{{ 'TABLE_NO_ELEMENT' | translate }}</td>
			</tr>
		</ng-template>
	</p-treeTable>
</div>

<p-confirmDialog #confDialog>
	<ng-template pTemplate="footer">
		<div class="col-12 flex justify-content-center">
			<button type="button" pButton [label]="confDialog.acceptButtonLabel" [ngClass]="acceptButtonStyle"
				(click)="confDialog.accept()">
			</button>
			<button type="button" pButton [label]="confDialog.rejectButtonLabel" [ngClass]="rejectButtonStyle"
				(click)="confDialog.reject()">
			</button>
		</div>
	</ng-template>
</p-confirmDialog>